import { RootState } from "@/infrastructure/rootState";
import { BacktestType } from "@/features/backtest";
import { oc } from "ts-optchain";

// Results:
export const result = ({ backtest }: RootState) => backtest.result;
export const featureImportance = ({ backtest }: RootState) => oc(backtest).result.featureImportance([]);
export const groupResult = ({ backtest }: RootState) => backtest.result.groupResult;
export const pfStrategyStats = ({ backtest }: RootState) => backtest.result.groupResult.strategy.portfolioStatistics;
export const strategyTradeLog = ({ backtest }: RootState) => backtest.result.groupResult.strategy.tradeLog;
export const strategyTransaction = ({ backtest }: RootState) =>
  backtest.result.groupResult.strategy.transactionsRecords;
export const strategyOhlc = ({ backtest }: RootState) => backtest.result.groupResult.strategy.ohlcWithIndicators;

export const strategyRoundTripSummary = ({ backtest }: RootState) =>
  oc(backtest).result.groupResult.strategy.portfolioRoundTripsSummary([]);
export const strategyRoundTripsPnl = ({ backtest }: RootState) =>
  oc(backtest).result.groupResult.strategy.portfolioRoundTripsProfitLosses([]);
export const strategyRoundTripsDuration = ({ backtest }: RootState) =>
  oc(backtest).result.groupResult.strategy.portfolioRoundTripsDuration([]);
export const strategyDrawDown = ({ backtest }: RootState) =>
  oc(backtest).result.groupResult.strategy.portfolioDrawdownTable([]);
export const strategyReturnsBySymbol = ({ backtest }: RootState) =>
  oc(backtest).result.groupResult.strategy.portfolioRoundTripsReturnsBySymbols([]);

export const resultNameMap = (): Record<keyof BacktestType.GroupResult, string> => ({
  strategy: "Strategy",
  longTerm: "Long Term Hold (LTH)",
  peerStrategy: "Strategy on Peers"
});

export const availableResultType = ({ backtest }: RootState) => {
  const nameMap = resultNameMap();

  return [
    ...Object.keys(backtest.result.groupResult).map(e => ({
      key: e,
      name: nameMap[e as keyof BacktestType.GroupResult]
    })),
    ...oc(backtest)
      .result.singleResult([])
      .map(e => ({ key: e.strategy, name: e.strategy }))
  ];
};
